import { JobCornSchema } from '@eigtech/restoration-types';
import { CurrentClaimCornSchema } from '@eigtech/shared-corn-helper';
import { z } from 'zod';
import { PhotoReportRecordSchema } from '../base/photoReport.js';
export const GetPhotoReportPathSchema = z.object({
    entityId: z.union([CurrentClaimCornSchema, JobCornSchema]),
});
export const GetPhotoReportResponseSchema = z.object({
    photoReport: PhotoReportRecordSchema,
    documentUrl: z.string().optional(),
});
export const GetPhotoReportRequestSchema = GetPhotoReportPathSchema;
export const GetPhotoReportApiSchema = {
    params: GetPhotoReportPathSchema,
    response: GetPhotoReportResponseSchema,
};
